var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.estaActivo)?_c('Navbar'):_vm._e(),_c('v-main',[_c('router-view',{attrs:{"popup":_vm.popupAlert}})],1),_c('alertas',{attrs:{"status":_vm.alertas.status,"message":_vm.alertas.message,"type":_vm.alertas.type},on:{"close":function($event){return _vm.closePopupAlert()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }